import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReportCommonService } from '../shared/services/report-common.service';
import { IsaveAs } from '../shared/models/saveAs-interface.model';

@Component({
  selector: 'save-as-filter-template',
  templateUrl: './save-as.component.html',
  styleUrls: ['./filtersdialog.component.scss']
})
export class SaveAsComponent implements OnInit {

  constructor(
    public commonData: ReportCommonService
    ){}

  @ViewChild('popupModal') public modal: any;
  @Input() public saveAsDialogOpened: boolean = false;
  @Output() public submitted = new EventEmitter();
  @Output() public canceled = new EventEmitter();
  @Output() public saveAsDialogOpenedChange = new EventEmitter();  

  public saveDisabled: boolean = true;
  public templateNameInUse: boolean = false;
  public templateNameRequired: boolean = false;
  public reservedNames: string[] = ['custom', 'unfiltered'];
  public result: IsaveAs = {name: '', isDefault: false};
  public isDefault: boolean = false;

  ngOnInit() {
    this.result.name = "";
  }

  public nameChanged(event:any){
    // compare to current template names and enable save button if
    // unique
    this.result.name = event.target.value.trimStart();
    this.saveDisabled = this.result.name === '' || this.reservedNames.includes(this.result.name.toLowerCase()) || this.commonData.TemplateExists(this.result.name.trim());
    this.templateNameInUse = (this.saveDisabled && (this.commonData.TemplateExists(this.result.name.trim()) || this.reservedNames.includes(this.result.name.toLowerCase())));
    this.templateNameRequired = (this.result.name === '');
  }
  public clickSaveAs(){
    this.submitted.emit(this.result.name.trim());
    this.result.name = "";
    this.saveAsDialogOpened = false;
  }
  public clickCancel(){
    this.canceled.emit();
    this.result.name = "";
    this.saveAsDialogOpened = false;
  }
  public close(){
    this.canceled.emit();
    this.result.name = "";
    this.saveAsDialogOpened = false;
  }
  public open() {
    this.saveAsDialogOpened = true;
  }
}
